import React from 'react';
import { Link } from 'react-router-dom';

function Contato() {
  return (
    <>
      <div className="header">
        <Link to="/" className="header-logo">
          <img src={require('../logo.png')} alt="PokerMind Brasil" style={{ height: '46px', objectFit: 'contain' }} />
        </Link>
        <Link to="/" className="header-back">← Voltar ao início</Link>
      </div>

      <div className="content">
        <div className="doc-tag">Suporte</div>
        <h1 className="doc-title">Fale Conosco</h1>
        <div className="doc-date">PokerMind Brasil · Atendimento por E-mail</div>

        <div className="highlight-box">
          <p>Nossa equipe está pronta para ajudar você. Envie sua mensagem e retornaremos o mais breve possível.</p>
        </div>

        <h2>📧 E-mail de Atendimento</h2>
        <p>Para dúvidas, sugestões, problemas técnicos ou qualquer outro assunto, entre em contato pelo nosso e-mail oficial:</p>

        <div style={{textAlign: 'center', margin: '40px 0'}}>
          <a
            href="mailto:contato@pokermindbrasil.com"
            style={{
              display: 'inline-block',
              background: 'var(--yellow)',
              color: 'var(--black)',
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 900,
              fontSize: '1.25rem',
              textTransform: 'uppercase',
              letterSpacing: '.06em',
              padding: '18px 40px',
              borderRadius: '10px',
              textDecoration: 'none',
              transition: 'opacity .2s',
            }}
            onMouseOver={e => e.currentTarget.style.opacity = '0.85'}
            onMouseOut={e => e.currentTarget.style.opacity = '1'}
          >
            contato@pokermindbrasil.com
          </a>
        </div>

        <h2>Para que serve este canal?</h2>
        <p>Utilize o e-mail acima para:</p>
        <ul>
          <li><strong>Suporte técnico</strong> — problemas de acesso, bugs ou comportamento inesperado na plataforma;</li>
          <li><strong>Dúvidas sobre planos</strong> — informações sobre assinaturas, cobranças e cancelamentos;</li>
          <li><strong>Sugestões de melhoria</strong> — ideias para novos recursos ou melhorias no produto;</li>
          <li><strong>Reportar problemas</strong> — comportamento incorreto do Coach IA ou erros no conteúdo;</li>
          <li><strong>Questões legais e privacidade</strong> — solicitações relacionadas a dados pessoais conforme nossa <Link to="/privacidade">Política de Privacidade</Link>.</li>
        </ul>

        <h2>Tempo de resposta</h2>
        <p>Respondemos todas as mensagens em até <strong>48 horas úteis</strong>. Para agilizar o atendimento, inclua em sua mensagem:</p>
        <ul>
          <li>O e-mail cadastrado na sua conta;</li>
          <li>Uma descrição clara do problema ou dúvida;</li>
          <li>Capturas de tela, se houver erro técnico.</li>
        </ul>

        <div className="highlight-box" style={{marginTop: '40px'}}>
          <p><strong>Cancelamentos e cobranças:</strong> Para cancelar sua assinatura, acesse diretamente o painel da <a href="https://kiwify.com.br" target="_blank" rel="noopener noreferrer">Kiwify</a> com o e-mail usado na compra.</p>
        </div>
      </div>

      <div className="footer">
        © 2026 PokerMind Brasil · <Link to="/">Início</Link> · <Link to="/privacidade">Política de Privacidade</Link> · <Link to="/termos">Termos de Uso</Link>
      </div>
    </>
  );
}

export default Contato;
